import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAccountMovementQuotation } from "src/models/Accounting/Accounting.models";
import { IInvoice } from "src/models/Stores/Invoice.models";

interface AccountMovementQuotationState {
    accountMovementQuotations: IAccountMovementQuotation[];
    accountMovementQuotationToEdit: IAccountMovementQuotation | null;
    invoicesPOS: IInvoice[];
    invoicePOSToEdit: IInvoice | null;
}

const initialState: AccountMovementQuotationState = {
    accountMovementQuotations: [],
    accountMovementQuotationToEdit: null,
    invoicesPOS: [],
    invoicePOSToEdit: null,
};

const AccountMovementQuotationSlice = createSlice({
    name: "AccountMovementQuotation",
    initialState,
    reducers: {
    setAccountMovementQuotationList: (
        state,
        action: PayloadAction<IAccountMovementQuotation[]>
    ) => {
        state.accountMovementQuotations = action.payload;
    },
    concatListAccountMovementQuotation: (
        state: AccountMovementQuotationState,
        action: PayloadAction<IAccountMovementQuotation[]>
    ) => {
        state.accountMovementQuotations = [
            ...state.accountMovementQuotations.concat(action.payload),
        ];
    },
    concatFirstListAccountMovementQuotation: (
        state: AccountMovementQuotationState,
        action: PayloadAction<IAccountMovementQuotation[]>
    ) => {
        state.accountMovementQuotations = [
            ...action.payload.concat(state.accountMovementQuotations),
        ];
    },
    setAccountMovementQuotationToEdit: (
        state,
        action: PayloadAction<IAccountMovementQuotation | null>
    ) => {
        state.accountMovementQuotationToEdit = action.payload;
    },
    setURLToAccountMovementQuotationToEdit: (
        state,
        action: PayloadAction<string | null>
    ) => {
        if (state.accountMovementQuotationToEdit)
        state.accountMovementQuotationToEdit.url = action.payload;
    },
    addAccountMovementQuotation: (state, action: PayloadAction<IAccountMovementQuotation>) => {
        state.accountMovementQuotations.unshift(action.payload);
    },
    addAccountMovementQuotations: (state, action: PayloadAction<IAccountMovementQuotation[]>) => {
        state.accountMovementQuotations.push(...action.payload);
    },
    updateAccountMovementQuotation: (state, action: PayloadAction<IAccountMovementQuotation>) => {
        let itemIndex = state.accountMovementQuotations.findIndex(
            item => item.accountMovementQuotationId === action.payload.accountMovementQuotationId
        );
        if (itemIndex !== -1) state.accountMovementQuotations[itemIndex] = action.payload;
    },
    updateAccountMovementQuotations: (state, action: PayloadAction<IAccountMovementQuotation[]>) => {
        action.payload.forEach(item => {
            let itemIndex = state.accountMovementQuotations.findIndex(
                accountMovementQuotation =>
                accountMovementQuotation.accountMovementQuotationId === item.accountMovementQuotationId
            );
            if (itemIndex !== -1) state.accountMovementQuotations[itemIndex] = item;
        });
    },
    deleteAccountMovementQuotation: (state, action: PayloadAction<number>) => {
        const newArray = state.accountMovementQuotations.filter(
            item => item.accountMovementQuotationId !== action.payload
        );
        state.accountMovementQuotations = newArray;
    },

    // INVOICE POS
    
    concatListInvoicePOS: (
        state: AccountMovementQuotationState,
        action: PayloadAction<IInvoice[]>
    ) => {
        state.invoicesPOS = [
            ...state.invoicesPOS.concat(action.payload),
        ];
    },
    setInvoicePOSList: (
        state,
        action: PayloadAction<IInvoice[]>
    ) => {
        state.invoicesPOS = action.payload;
    },
}
});

export const {
    setAccountMovementQuotationList,
    concatListAccountMovementQuotation,
    concatFirstListAccountMovementQuotation,
    setAccountMovementQuotationToEdit,
    setURLToAccountMovementQuotationToEdit,
    addAccountMovementQuotation,
    addAccountMovementQuotations,
    updateAccountMovementQuotation,
    updateAccountMovementQuotations,
    deleteAccountMovementQuotation,

    // INVOICE POS
    concatListInvoicePOS,
    setInvoicePOSList,
} = AccountMovementQuotationSlice.actions;

export default AccountMovementQuotationSlice.reducer;